@if (!!meeting) {
    <div class="card">
        <div class="card-header pt-2 d-flex align-items-center">
            <h3 class="mb-0"
                data-test="meeting-name-heading">
                {{ meeting.name }}
            </h3>
            @if (meeting && meeting.supplementaryData && meeting.supplementaryData.purpose) {
                <button [(adaptCollapsibleButton)]="purposeCollapsed"
                        [adaptTooltip]="purposeCollapsed ? 'Show Description' : 'Hide Description'"
                        data-test="meeting-description-display-toggle"
                        class="ms-2"></button>
            }
            <div class="ms-auto d-flex me-2">
                @if (canStart) {
                    <button adaptButtonIcon="fal fa-fw fa-play-circle"
                            [adaptBlockingClick]="startMeeting"
                            class="btn btn-primary text-nowrap"
                            [unsubscribeOnDestroy]="false"
                            data-test="start-meeting-button">Start</button>
                }
                <adapt-meeting-details-menu [meeting]="meeting"
                                            [update$]="triggerUpdate$"
                                            [(showAgendaEditor)]="showAgendaEditor"
                                            (showAgendaEditorChange)="editorToggled = $event"
                                            (meetingChange)="meetingChange.emit($event)"
                                            (meetingDeleted)="meetingDeleted.emit($event)"></adapt-meeting-details-menu>
            </div>
        </div>
        <div class="card-body">
            <dx-scroll-view #meetingDetailsScrollView
                            (onScroll)="meetingDetailsScrolled.emit($event)">
                @if (nonStartableMeetingInfo) {
                    <div class="alert alert-warning mb-3">
                        {{ nonStartableMeetingInfo }}
                    </div>
                }
                <div class="d-flex align-items-center">
                    <div class="d-flex flex-column flex-grow-1">
                        <div title="When this meeting will take place">
                            <span><i class="fal fa-fw fa-clock me-1"></i>{{ meeting.meetingDateTime | adaptDate }}</span>
                            <span class="mx-2">/</span>
                            <span>{{ meeting.meetingDateTime | adaptTime }}</span>
                            @if (meeting.endTime) {
                                <span class="mx-1">-</span>
                                <span>{{ meeting.endTime | adaptTime }}</span>
                            }
                        </div>
                        @if (meeting.location) {
                            <div title="Where this meeting will take place">
                                <span><i class="fal fa-fw fa-location-dot me-1"></i>{{ meeting.location }}</span>
                            </div>
                        }
                        @if (currentPersonIsAttendee) {
                            <adapt-link-external-meeting [meeting]="meeting"></adapt-link-external-meeting>
                        }
                    </div>
                </div>
                <adapt-display-meeting-participants class="align-self-baseline meeting-participants pt-2"
                                                    [participants]="participants"></adapt-display-meeting-participants>
                @if (meeting && meeting.supplementaryData && meeting.supplementaryData.purpose) {
                    <adapt-dashboard-element [collapse]="purposeCollapsed"
                                             [isAnimated]="true"
                                             [nested]="true"
                                             class="mb-0"
                                             name="Description"
                                             data-test="meeting-description-display">
                        <div class="pb-4"
                             [froalaView]="meeting.supplementaryData.purpose"></div>
                    </adapt-dashboard-element>
                }
                <adapt-dashboard-element name="Agenda"
                                         [nested]="true">
                    @if (isInProgress && isCurrentPersonInMeeting) {
                        <div class="alert alert-info">The agenda for this meeting can only be modified from the live meeting sidebar or
                            page.</div>
                    }
                    <ng-container adapt-dashboard-title-buttons>
                        @if (canExpand) {
                            <button adaptButtonIcon="align-self-center fal fa-fw {{ agendaExpanded ? 'fa-chevron-up' : 'fa-chevron-down' }}"
                                    class="btn btn-blank"
                                    (click)="toggleExpand()">{{ agendaExpanded ? "Collapse" : "Expand" }} all agenda items</button>
                        }
                    </ng-container>
                    <!-- Only meeting that's not started is editable -->
                    @if (showAgendaEditor && canEditMeeting) {
                        <adapt-edit-agenda [meeting]="meeting"
                                           [expandItemsOnInit]="false"
                                           (expandChange)="agendaExpanded = $event"
                                           (canExpandChange)="canExpand = $event"></adapt-edit-agenda>
                    } @else {
                        <adapt-display-agenda-items [agendaItems]="agendaItems"
                                                    [displayOptions]="displayOptions"
                                                    [expandItemsOnInit]="true"
                                                    (expandChange)="agendaExpanded = $event"
                                                    (canExpandChange)="canExpand = $event"></adapt-display-agenda-items>
                    }
                </adapt-dashboard-element>
            </dx-scroll-view>
        </div>
    </div>
}
